export const mutation_add_autovalutazione = `
mutation addAutovalutazione($tenantId: String!, $aziendaId: Int!, $tenantTipoId: Int!, $date: timestamp!, $ri1: Int!, $ri2: Int!, $ri3: Int!, $ri4: Int!, $lv1: Int!, $lv2: Int!, $lv3: Int!, $lv4: Int!, $riTotale: numeric!, $lvTotale: numeric!, $rrTotale: numeric!, $livelloRischio: Int!, $providedBy: String!, $note: String!,$expireDate: date!) {
    insert_autovalutazione_one(object: {TenantId: $tenantId, AziendaId: $aziendaId, TenantTipoId: $tenantTipoId, Date: $date, Ri1: $ri1, Ri2: $ri2, Ri3: $ri3, Ri4: $ri4, Lv1: $lv1, Lv2: $lv2, Lv3: $lv3, Lv4: $lv4, RiTotale: $riTotale, LvTotale: $lvTotale, RrTotale: $rrTotale, LivelloRischio: $livelloRischio, ProvidedBy: $providedBy, Note: $note, ExpireDate:$expireDate}) {
        Id
        TenantId
        AziendaId
        TenantTipoId
        Date
        Ri1
        Ri2
        Ri3
        Ri4
        Lv1
        Lv2
        Lv3
        Lv4
        RiTotale
        LvTotale
        RrTotale
        LivelloRischio
        ProvidedBy
        Note
        CreatedOn
        ModifiedOn
        CreatedBy
        ModifiedBy
        ExpireDate
    }
}`;
export const mutation_update_autovalutazione = `
mutation updateAutovalutazione($id: Int!, $tenantId: String!, $aziendaId: Int!, $tenantTipoId: Int!, $date: timestamp!, $ri1: Int!, $ri2: Int!, $ri3: Int!, $ri4: Int!, $lv1: Int!, $lv2: Int!, $lv3: Int!, $lv4: Int!, $riTotale: numeric!, $lvTotale: numeric!, $rrTotale: numeric!, $livelloRischio: Int!, $providedBy: String!, $note: String!,$expireDate: date!) {
    update_autovalutazione(where: {Id: {_eq: $id}, TenantId: {_eq: $tenantId}, AziendaId: {_eq: $aziendaId}}, _set: {TenantTipoId: $tenantTipoId, Date: $date, Ri1: $ri1, Ri2: $ri2, Ri3: $ri3, Ri4: $ri4, Lv1: $lv1, Lv2: $lv2, Lv3: $lv3, Lv4: $lv4, RiTotale: $riTotale, LvTotale: $lvTotale, RrTotale: $rrTotale, LivelloRischio: $livelloRischio, ProvidedBy: $providedBy, Note: $note, ModifiedOn: "now()", ExpireDate:$expireDate}) {
        returning {
            Id
            TenantId
            AziendaId
            TenantTipoId
            Date
            Ri1
            Ri2
            Ri3
            Ri4
            Lv1
            Lv2
            Lv3
            Lv4
            RiTotale
            LvTotale
            RrTotale
            LivelloRischio
            ProvidedBy
            Note
            CreatedOn
            ModifiedOn
            CreatedBy
            ModifiedBy
            ExpireDate
        }
    }
}`;
export const mutation_delete_autovalutazione = `
mutation deleteAutovalutazione($id: Int!) {
    delete_autovalutazione(where: {Id: {_eq: $id}}) {
        affected_rows
        }
}`;